<template>
  <div :class="$style.flexContainer">
    <svg :class="$style.loader" viewBox="0 0 24 24">
      <circle :class="$style.loaderValue" cx="12" cy="12" r="10"/>
      <circle :class="$style.loaderValue" cx="12" cy="12" r="10"/>
      <circle :class="$style.loaderValue" cx="12" cy="12" r="10"/>
      <circle :class="$style.loaderValue" cx="12" cy="12" r="10"/>
      <circle :class="$style.loaderValue" cx="12" cy="12" r="10"/>
      <circle :class="$style.loaderValue" cx="12" cy="12" r="10"/>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'Loader',
  }
</script>

<style lang="scss" module>
  @import '@design';

  $loader-colors: $color-primary-dark, $color-contrast, $color-secondary;
  $loader-dash: 63;
  $loader-duration: length($loader-colors) * 1.2s;
  $loader-duration-alt: $loader-duration / length($loader-colors);
  $loader-keyframe: 1 / (length($loader-colors) * 2) * 100;

  .flexContainer {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: auto;
  }

  .loader {
    width: 100%;
    max-width: 60px;
    padding: 1rem;
    animation: loader-turn $loader-duration-alt linear infinite;
  }

  .loaderValue {
    fill: none;
    stroke-dasharray: $loader-dash;
    stroke-dashoffset: $loader-dash;
    stroke-linecap: round;
    stroke-width: 3;
    animation: loader-stroke $loader-duration linear infinite;

    @for $i from 1 through length($loader-colors) {
      &:nth-child(#{$i}) {
        stroke: nth($loader-colors, $i);

        @if $i > 1 {
          animation-delay: ($i - 1) * $loader-duration-alt;
        }
      }
    }
  }

  @keyframes loader-stroke {
    #{$loader-keyframe * 1%} {
      stroke-dashoffset: 0;
    }
    #{$loader-keyframe * 2%},
    100% {
      stroke-dashoffset: $loader-dash;
    }
  }

  @keyframes loader-turn {
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(720deg);
    }
  }
</style>
